<template>
  <vuex-table
    :fields="fields"
    :show_header="false"
    :tbody_tr_class="row_class"
    table_store="pbx/phone-lists/form/table"
  >
    <template slot="actions" slot-scope="{ item }">
      <table-control type="trash" @click="remove_item(item)" />
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('pbx/phone-lists/form/table', { changes: 'changes' }),

      fields: function () {
        return [
          {
            key: 'phone',
            label: this.$t('pbx.phone-list.form.field.phone'),
            sortable: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center'
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/phone-lists/table', ['getAsyncData']),

      row_class: function (item) {
        if (item) {
          const changes_ids = this.changes.map((i) => i.id);
          return changes_ids.includes(item.id) ? 'tr--disabled' : '';
        }
        return false;
      },
      remove_item: function (item) {
        this.$emit('on-remove', item);
      }
    }
  };
</script>
